import ShopifySettings from './shopify-settings';

export default ShopifySettings;
